import { defineComponent as _defineComponent } from 'vue'
import { parse } from 'date-fns';
import { onMounted, onUnmounted, ref } from 'vue';

interface Props {
  imageUrl?: string;
  hotelUrl?: string;
  startDate?: string;
  endDate?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SpiceHotelBanner',
  props: {
    imageUrl: { default: '' },
    hotelUrl: { default: 'https://travelata.ru/turkey/resorts/belek/hotels/spice-hotel-spa-5-f8df105.html' },
    startDate: { default: '2025-12-15' },
    endDate: { default: '2025-12-22' }
  },
  setup(__props: any) {

const props = __props as { imageUrl: string, hotelUrl: string, startDate: string, endDate: string }



const TARGET_COUNTRY_ID = '92';

const isVisible = ref(false);

const checkDateRange = (): boolean => {
  const now = new Date();

  const start = parse(props.startDate, 'yyyy-MM-dd', new Date());
  const end = parse(props.endDate, 'yyyy-MM-dd', new Date());
  end.setHours(23, 59, 59, 999);

  const nowDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startDateOnly = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const endDateOnly = new Date(end.getFullYear(), end.getMonth(), end.getDate());

  return nowDateOnly >= startDateOnly && nowDateOnly <= endDateOnly;
};

const checkVisibility = (): void => {
  const hashParams = new URLSearchParams(window.location.hash);
  const toCountry = hashParams.get('toCountry');
  const isToCountry = toCountry === TARGET_COUNTRY_ID;
  const isTurkeyPage = window.location.pathname.includes('/turkey') || isToCountry;
  const isInDateRange = checkDateRange();

  isVisible.value = isTurkeyPage && isInDateRange;
};

let originalPushState: typeof history.pushState | null = null;
let originalReplaceState: typeof history.replaceState | null = null;

onMounted(() => {
  if (typeof window === 'undefined') {
    return;
  }

  checkVisibility();

  window.addEventListener('popstate', checkVisibility);
  window.addEventListener('hashchange', checkVisibility);

  originalPushState = history.pushState.bind(history);
  originalReplaceState = history.replaceState.bind(history);

  history.pushState = function(...args) {
    originalPushState?.apply(history, args);
    checkVisibility();
  };

  history.replaceState = function(...args) {
    originalReplaceState?.apply(history, args);
    checkVisibility();
  };
});

onUnmounted(() => {
  if (typeof window === 'undefined') {
    return;
  }
// TODO: Заменить на использование композабла useRoute из vue-router после обновления
  window.removeEventListener('popstate', checkVisibility);
  window.removeEventListener('hashchange', checkVisibility);

  if (originalPushState) {
    history.pushState = originalPushState;
  }
  if (originalReplaceState) {
    history.replaceState = originalReplaceState;
  }
});

const openLinkHotel = () => {
  if (typeof window !== 'undefined') {
    window.open(props.hotelUrl, '_blank');
  }
};


return { __sfc: true,props, TARGET_COUNTRY_ID, isVisible, checkDateRange, checkVisibility, originalPushState, originalReplaceState, openLinkHotel }
}

})